/**
* Closest Scrollable Parent
*/
export function getClosestScrollableParent (element) {
  let currentElement = element

  while (currentElement) {
    const styles = window.getComputedStyle(currentElement)
    const overflowY = styles.overflowY
 
    if (((overflowY === 'auto' || overflowY === 'scroll') && currentElement.scrollHeight > currentElement.clientHeight) || currentElement.getAttribute('scroll-scope')) {
      return currentElement
    }

    currentElement = currentElement.parentElement
  }
    

  if ((document.documentElement.scrollHeight > document.documentElement.clientHeight) || (document.body.scrollHeight > document.body.clientHeight)) {
    return document.documentElement
  }

  return null
}
 
/**
* Scroll To
* scrollTo('', selectorTo, -400, element)
*/
export function scrollTo (e, selector, yOffset = -80, blockSelector) {
  const scrollableParent = getClosestScrollableParent(blockSelector)

  if (e) {
    e.preventDefault()
  }

  let overflowYValue = null
  if (scrollableParent) {
    const styles = window.getComputedStyle(scrollableParent)
    overflowYValue = styles.getPropertyValue('overflow-y') ? styles.getPropertyValue('overflow-y') : scrollableParent.getAttribute('overflow-y')
  }

  const element = (typeof selector === 'object') ? selector : document.querySelector(selector)

  if (!blockSelector) {
    blockSelector = window
  }
    
  if (overflowYValue !== null && overflowYValue !== 'hidden') {
    const y = useElementBounding(element).top.value + (scrollableParent ? useScroll(scrollableParent).y.value : useScroll(window).y.value) + yOffset
    scrollableParent.scrollTo({ top: y, behavior: 'smooth' })
  } else {
    const y = useElementBounding(element).top.value + useScroll(window).y.value + yOffset
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
}

/**
* Download File from Api
* Example: @click="downloadFile(getCampaignsDownloads('campaignEmailsTemplate'), 'campaignEmailsTemplate.svg')"
*/
export async function downloadFile (response, fileName) {
  try {
    const url = window.URL.createObjectURL(new Blob([await response]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
  } catch (error) {
    console.error(error)
  }
}
